const SPLASH = [[750, 1334, 2], [828, 1792, 2], [1125, 2436, 3], [1170, 2532, 3], [1179, 2556, 3], [1242, 2688, 3], [1284, 2778, 3], [1290, 2796, 3]];

const tag = (name, attrs) => {
  const el = document.createElement(name);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  el.dataset.portalPwa = "1";
  document.head.appendChild(el);
};

export function applyPortalPwa() {
  if (document.head.querySelector("[data-portal-pwa]")) return;
  const m = document.querySelector("link[rel=manifest]");
  if (m) m.href = "/portail-manifest.json"; else tag("link", { rel: "manifest", href: "/portail-manifest.json" });
  document.querySelectorAll("link[rel=apple-touch-icon], meta[name=apple-mobile-web-app-title], meta[name=theme-color]").forEach((e) => e.remove());
  tag("link", { rel: "apple-touch-icon", href: "/portail-icons/icon-180.png" });
  tag("meta", { name: "apple-mobile-web-app-title", content: "OMNIBAT Client" });
  tag("meta", { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" });
  tag("meta", { name: "theme-color", content: "#076633" });
  SPLASH.forEach(([w, h, r]) => tag("link", { rel: "apple-touch-startup-image", href: `/portail-icons/splash-${w}x${h}.png`,
    media: `(device-width: ${w / r}px) and (device-height: ${h / r}px) and (-webkit-device-pixel-ratio: ${r}) and (orientation: portrait)` }));
  document.title = "OMNIBAT — Espace client";
}
